<template>
  <vx-card title="">
    <div slot="no-body" class="p-6">
      <dx-data-grid
        style="width: 100%"
        class="dx-card wide-card"
        :data-source="customDataSource"
        :show-borders="false"
        :focused-row-enabled="false"
        :column-auto-width="true"
        :column-hiding-enabled="true"
        :ref="dataGridRefKey"
      >
        >
        <dx-paging :page-size="20" />
        <dx-pager :show-page-size-selector="true" :show-info="true" />
        <dx-filter-row :visible="true" />

        <dx-column
          data-field="displayName"
          :caption="dimensionCaption"
          :visible="showDimension"
          :width="190"
          :hiding-priority="99"
        />
        <dx-column
          data-field="date"
          :caption="$t('Statistics.Date')"
          data-type="date"
          :width="190"
          :hiding-priority="98"
          :visible="showDate"
        />
        <dx-column
          data-field="revenue"
          :caption="$t('Statistics.Costs')"
          data-type="number"
          :width="100"
          :hiding-priority="97"
          :visible="regularView"
        >
          <dx-format type="currency" :precision="2"></dx-format>
        </dx-column>
        <dx-column
          data-field="impressions"
          :caption="$t('Statistics.Impressions')"
          data-type="number"
          :width="130"
          :hiding-priority="96"
          :visible="regularView"
        />
        <dx-column
          data-field="clicks"
          :caption="$t('Statistics.Clicks')"
          data-type="number"
          :width="100"
          :hiding-priority="8"
          sort-order="desc"
          :visible="regularView"
        />
        <dx-column
          data-field="uniqueClicks"
          :caption="$t('Statistics.UniqueClicks')"
          data-type="number"
          :width="130"
          :hiding-priority="95"
          :visible="regularView"
        />
        <dx-column
          data-field="ctr"
          :caption="$t('Statistics.Ctr')"
          data-type="number"
          :width="100"
          :hiding-priority="94"
          :customize-text="percentageFormat"
          :visible="regularView"
        >
          <dx-format type="fixedpoint" :precision="2"></dx-format>
        </dx-column>
        <dx-column
          data-field="cpm"
          :caption="$t('Statistics.Cpm')"
          data-type="number"
          :width="100"
          :hiding-priority="93"
          :visible="regularView"
        >
          <dx-format type="currency" :precision="2"></dx-format>
        </dx-column>
        <dx-column
          data-field="cpc"
          :caption="$t('Statistics.Cpc')"
          data-type="number"
          :width="100"
          :hiding-priority="92"
          :visible="regularView"
        >
          <dx-format type="currency" :precision="2"></dx-format>
        </dx-column>
        <dx-column
          data-field="postViewConversions"
          :caption="$t('Statistics.ConvPv')"
          data-type="number"
          :width="100"
          :hiding-priority="91"
          :visible="regularView"
        />
        <dx-column
          data-field="postClickConversions"
          :caption="$t('Statistics.ConvPc')"
          data-type="number"
          :width="100"
          :hiding-priority="8"
          :visible="regularView"
        />
        <dx-column
          data-field="totalConversions"
          :caption="$t('Statistics.ConvTotal')"
          data-type="number"
          :width="100"
          :hiding-priority="90"
          :visible="regularView"
        />

        <dx-column
          data-field="revenuePercentage"
          caption="costs"
          data-type="number"
          :width="100"
          :hiding-priority="94"
          :customize-text="percentageFormat"
          :visible="percentageView"
        >
          <dx-format type="fixedpoint" :precision="0"></dx-format>
        </dx-column>
        <dx-column
          data-field="impressionsPercentage"
          caption="impressions"
          data-type="number"
          :width="100"
          :hiding-priority="94"
          :customize-text="percentageFormat"
          :visible="percentageView"
        >
          <dx-format type="fixedpoint" :precision="0"></dx-format>
        </dx-column>
        <dx-column
          caption=""
          data-type="number"
          :width="100"
          :hiding-priority="999"
        />
        <dx-summary :calculate-custom-summary="calculateCustomSummary">
          <dx-total-item
            column="impressions"
            summary-type="sum"
            :value-format="{ type: 'largeNumber', precision: 0 }"
            displayFormat="{0}"
          />
          <dx-total-item
            column="clicks"
            summary-type="sum"
            :value-format="{ type: 'largeNumber', precision: 0 }"
            displayFormat="{0}"
          />
          <dx-total-item
            column="uniqueClicks"
            summary-type="sum"
            :value-format="{ type: 'largeNumber', precision: 0 }"
            displayFormat="{0}"
          />
          <dx-total-item
            column="revenue"
            summary-type="sum"
            :value-format="{ type: 'currency', precision: 2, currency: 'EUR' }"
            displayFormat="{0}"
          />
          <dx-total-item
            show-in-column="ctr"
            name="ctrSum"
            summary-type="custom"
            :value-format="{ type: 'percent', precision: 2 }"
            display-format="{0}"
          />
          <dx-total-item
            show-in-column="cpm"
            name="cpmSum"
            summary-type="custom"
            :value-format="{ type: 'currency', precision: 2, currency: 'EUR' }"
            display-format="{0}"
          />
          <dx-total-item
            show-in-column="cpc"
            name="cpcSum"
            summary-type="custom"
            :value-format="{ type: 'currency', precision: 2, currency: 'EUR' }"
            display-format="{0}"
          />
          <dx-total-item
            column="postViewConversions"
            summary-type="sum"
            :value-format="{ type: 'largeNumber', precision: 0 }"
            displayFormat="{0}"
          />
          <dx-total-item
            column="postClickConversions"
            summary-type="sum"
            :value-format="{ type: 'largeNumber', precision: 0 }"
            displayFormat="{0}"
          />
          <dx-total-item
            column="totalConversions"
            summary-type="sum"
            :value-format="{ type: 'largeNumber', precision: 0 }"
            displayFormat="{0}"
          />
        </dx-summary>
      </dx-data-grid>
    </div>
  </vx-card>
</template>

<script>
import CustomStore from 'devextreme/data/custom_store'
import DxDataGrid, {
  DxColumn,
  DxFormat,
  DxFilterRow,
  DxPager,
  DxPaging,
  DxSummary,
  DxTotalItem
} from "devextreme-vue/data-grid"
let _this = this
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFormat,
    DxFilterRow,
    DxPager,
    DxPaging,
    DxSummary,
    DxTotalItem
  },
  props: {
    masterDetailData: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    const secondaryDimension = this.$store.state.statistics.secondaryDimension
    const customDataSource = new CustomStore({
      key: 'id',
      load: () => {
        const payload = {
          idCampaign: this.activeCampaignId,
          startDate: this.range.start,
          endDate: this.range.end,
          dimension: this.dimension,
          secondaryDimension: secondaryDimension,
          dimensionFilter: this.masterDetailData.key
        }
        return this.$store
          .dispatch("statistics/fetchStatistics", payload)
          .then((res) => {
            return res.data.items
          })
          .catch((error) => {
            console.log(`error loading statistics: ${error}`)
          })
      }
    })

    return {
      dataGridRefKey: `grid-statistics-${secondaryDimension}`,
      customDataSource
    }
  },
  created () {
    _this = this
  },
  mounted () {
    if (this.isLoading) {
      this.dataGrid.beginCustomLoading()
    }
  },
  methods: {
    percentageFormat (cellInfo) {
      if (!cellInfo.valueText) {
        return ""
      }
      return `${cellInfo.valueText}%`
    },
    refreshDataGrid () {
      this.dataGrid.refresh()
    },
    calculateCustomSummary (options) {
      if (options.name == "ctrSum") {
        switch (options.summaryProcess) {
          case "start":
            options.totalValue = 0
            _this.totalImpressions = 0
            _this.totalClicks = 0
            break
          case "calculate":
            _this.totalImpressions += options.value.impressions
            _this.totalClicks += options.value.clicks
            break
          case "finalize":
            if (!_this.totalImpressions || !_this.totalClicks) {
              options.totalValue = null
            } else {
              options.totalValue = _this.totalClicks / _this.totalImpressions
            }
            break
        }
      }
      if (options.name == "cpcSum") {
        switch (options.summaryProcess) {
          case "start":
            options.totalValue = 0
            _this.totalRevenue = 0
            _this.totalClicks2 = 0
            break
          case "calculate":
            _this.totalRevenue += (options.value.revenue || 0)
            _this.totalClicks2 += options.value.clicks
            break
          case "finalize":
            if (!_this.totalClicks2 || !_this.totalRevenue) {
              options.totalValue = null
            } else {
              options.totalValue = _this.totalRevenue / _this.totalClicks2
            }
            break
        }
      }
      if (options.name == "cpmSum") {
        switch (options.summaryProcess) {
          case "start":
            options.totalValue = 0
            _this.totalRevenue2 = 0
            _this.totalImpressions2 = 0
            break
          case "calculate":
            _this.totalRevenue2 += (options.value.revenue || 0)
            _this.totalImpressions2 += options.value.impressions
            break
          case "finalize":
            if (!_this.totalImpressions2 || !_this.totalRevenue2) {
              options.totalValue = null
            } else {
              options.totalValue = _this.totalRevenue2 / _this.totalImpressions2 * 1000
            }
            break
        }
      }
    }
  },
  computed: {
    dataGrid: function () {
      return this.$refs[this.dataGridRefKey].instance
    },
    range: function () {
      return this.$store.state.statistics.range
    },
    dimension: function () {
      return this.$store.state.statistics.dimension
    },
    secondaryDimension: function () {
      return this.$store.state.statistics.secondaryDimension
    },
    activeCampaignId () {
      return this.$store.state.AppActiveUser.activeCampaignId
    },
    isLoading: function () {
      return this.$store.state.statistics.isLoading
    },
    showDimension: function () {
      return this.secondaryDimension !== "Date"
    },
    showDate: function () {
      return this.secondaryDimension === "Date"
    },
    dimensionData: function () {
      const dimensions = this.$store.state.statistics.dimensions
      for (let i = 0; i < dimensions.length; i++) {
        for (let j = 0; j < dimensions[i].group.length; j++) {
          const item = dimensions[i].group[j]
          if (item.value === this.secondaryDimension) {
            return item
          }
        }
      }
      return null
    },
    dimensionCaption: function () {
      if (this.dimensionData) {
        return this.dimensionData.text
      }
      return this.dimension
    },
    regularView: function () {
      if (this.dimensionData) {
        return !this.dimensionData.percentageView
      }
      return true
    },
    percentageView: function () {
      if (this.dimensionData) {
        return this.dimensionData.percentageView
      }
      return false
    }
  },
}
</script>